import configConstants from '../constants';

export function config(state = {denyReasons: [], fuelTypes: [], travelMethods: []}, action) {
    switch (action.type) {
        case configConstants.CONFIG_LOAD_STARTED: 
            return {
                ...state,
                requesting: true
            }
        case configConstants.CONFIG_LOAD_ENDED: 
            return {
                ...state,
                requesting: false,
            }
        case configConstants.APP_CONFIG_SUCCESS:
            return {
                ...state,
                ...action                
            };
        case configConstants.DENY_REASONS_SUCCESS:
            return {
                ...state,
                denyReasons: action.denyReasons || [],
                requesting: false
            };
        case configConstants.FUEL_TYPES_SUCCESS:
            return {
                ...state,
                fuelTypes: action.fuelTypes || [],
                requesting: false
            };
        case configConstants.TRAVEL_METHODS_SUCCESS:
            return {
                ...state,
                travelMethods: action.travelMethods || [],
                requesting: false
            };
        default: return state;
    }
}